import { render, staticRenderFns } from "./render-rich-text.vue?vue&type=template&id=fcbda7b4&"
import script from "./render-rich-text.vue?vue&type=script&lang=js&"
export * from "./render-rich-text.vue?vue&type=script&lang=js&"
import style0 from "./render-rich-text.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports